import "./InstructionsCard.scss";
import { NavigationSteps } from "../molecules/navigation-steps/NavigationSteps";
import Button from "../molecules/Button";

export const InstructionsCard = ({
  instructions,
  currentStep,
  nextStep,
  setStep,
  onMinify,
  isMinified,
  isCompleted,
}) => (
  <div className="d-none d-lg-block d-xl-block">
    {isCompleted && !isMinified && (
      <div className="instructions-card-completed p-10">
        <div className="instructions-heading">
          <button 
            className="minify-btn" 
            onClick={onMinify}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75"
              />
            </svg>
          </button>
        </div>
        <div className="instructions-body px-5">
          {instructions.map((instruction, index) => (
            <div key={index} className="instructions-body">
              <img className="instructions-img" src={instructions[index].img}></img>
              <p className="mb-5">{instruction.description}</p>
            </div>
          ))}
        </div>
      </div>
    )}
    {!isCompleted && !isMinified && currentStep !== null && (
      <div className="instructions-card">
        <div className="instructions-heading">
          {currentStep !== instructions.length ? (
            <button 
              className="minify-btn" 
              onClick={onMinify}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M5.25 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75"
                />
              </svg>
            </button>
          ) : <div></div>}
        </div>
        <div className="instructions-body px-5">
          <img className="instructions-img" src={instructions[currentStep - 1].img} alt="img" />
          <p>{instructions[currentStep - 1].description}</p>
        </div>
        <div className="instructions-nav">
          <NavigationSteps
            stepsLength={instructions.length}
            currentStep={currentStep}
            setStep={setStep}
          />
        </div>
        <div className="instructions-footer">
          <Button 
            onClick={currentStep === instructions.length ? onMinify : nextStep} 
            className="btn btn-custom"
            baseClass=""
            small
          >
            {instructions[currentStep - 1].btnName}
          </Button>
        </div>
      </div>
    )}
  </div>
);
